// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2pTfi","col":"Table_col__2CwBx","fulfillmentStatus":"Table_fulfillmentStatus__1EzzX","emailCol":"Table_emailCol__2lpTX"};